<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')">
    <div class="w-full max-w-lg mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody>
          <div v-show="!isDefault" class="mb-4">
            <button
              type="button"
              class="relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md bg-white focus:outline-none border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
              @click="setCurrentComponent('default')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 mr-3 -ml-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              Back
            </button>
          </div>
          <component
            :is="currentComponent"
            @set-option="setCurrentComponent"
            @apply-filter="applyFilter"
            @cancel="$emit('hide')"
          />
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import { omit } from 'lodash-es';
import { GROUP_DATE_CREATED, GROUP_PIPELINE_STAGE, filtersByGroup } from './filter-options';
import FilterList from './filter-list.vue';
import FilterPipelineStage from './filter-pipeline-stage.vue';
import FilterDateCreated from './filter-date-created.vue';

const DEFAULT_COMPONENT = 'FilterList';

const componentByGroup = {
  [GROUP_PIPELINE_STAGE]: 'FilterPipelineStage',
  [GROUP_DATE_CREATED]: 'FilterDateCreated',
};

const findFilterGroup = (filter) =>
  Object.keys(filtersByGroup).find((group) => filtersByGroup[group].indexOf(filter) >= 0);

const getFiltersNotInGroup = (filters, group) => {
  const currentFilters = { ...filters };
  const groupFilters = filtersByGroup[group];

  if (typeof groupFilters === 'undefined') {
    return currentFilters;
  }

  return omit(currentFilters, groupFilters);
};

export default {
  components: {
    FilterList,
    FilterPipelineStage,
    FilterDateCreated,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentComponent: DEFAULT_COMPONENT,
    };
  },
  computed: {
    isDefault() {
      return this.currentComponent === DEFAULT_COMPONENT;
    },
  },
  methods: {
    setCurrentComponent(component) {
      this.currentComponent = componentByGroup[component] || DEFAULT_COMPONENT;
    },
    applyFilter(filter) {
      const group = findFilterGroup(filter.key);

      if (typeof group === 'undefined') {
        return;
      }

      const remainingFilters = getFiltersNotInGroup(this.filters, group);

      this.$emit('update', { ...remainingFilters, [filter.key]: filter.value });
    },
  },
};
</script>
